import { render, staticRenderFns } from "./LoginDorm.vue?vue&type=template&id=d2d7f784&"
import script from "./LoginDorm.vue?vue&type=script&lang=js&"
export * from "./LoginDorm.vue?vue&type=script&lang=js&"
import style0 from "./LoginDorm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports